export const SET_TAXES_FLAG = 'SET_TAXES_FLAG'
export const SET_SYSTEM_ACTIVITY_LOG = 'SET_SYSTEM_ACTIVITY_LOG'



// WEBPACK FOOTER //
// ./src/types/flag.js